

/* Chak Chak: keep product media synced to the selected color. */
(() => {
  if (window.__ccColorMediaSyncAsset) return;
  window.__ccColorMediaSyncAsset = true;

  const slug = (value) => String(value || '')
    .toLowerCase()
    .trim()
    .replace(/grey/g, 'gray')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const selectedColor = () => {
    const checked = [...document.querySelectorAll('input[type=\"radio\"]:checked')];
    for (const input of checked) {
      const fieldset = input.closest('fieldset');
      const legend = fieldset?.querySelector('legend');
      const context = [input.name, input.getAttribute('aria-label'), legend?.textContent]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      if (context.includes('color') || context.includes('colour')) return input.value;
    }

    for (const select of document.querySelectorAll('select')) {
      const context = [select.name, select.getAttribute('aria-label')]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      if (context.includes('color') || context.includes('colour')) return select.value;
    }
    return '';
  };

  const syncColorMedia = () => {
    const color = selectedColor();
    if (!color) return;
    const wanted = slug(color);
    const wantedGrey = wanted.replace(/gray/g, 'grey');
    const matches = [...document.querySelectorAll('slideshow-controls img')].filter((img) => {
      const source = (img.currentSrc || img.src || img.dataset.src || '').split('?')[0].toLowerCase();
      return source.replace(/grey/g, 'gray').includes(wanted) || source.includes(wantedGrey);
    });
    if (!matches.length) return;
    const image = matches.find((img) => !img.closest('.product-details')) || matches[0];
    image.closest('button, [role=\"button\"], label')?.click();
  };

  const scheduleColorMedia = () => {
    [40, 300, 700, 1200].forEach((delay) => setTimeout(syncColorMedia, delay));
  };

  document.addEventListener('change', (event) => {
    if (event.target?.matches('input[type=\"radio\"], select')) scheduleColorMedia();
  }, true);
  document.addEventListener('variant:change', scheduleColorMedia);
  document.addEventListener('product:variant-change', scheduleColorMedia);
})();

(() => {
  const initialized = new WeakSet();
  const tasteCookieName = 'chakchak_taste_v1';

  const preferenceCookiesAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return !privacy || typeof privacy.preferencesProcessingAllowed !== 'function' || privacy.preferencesProcessingAllowed();
  };

  const readTasteProfile = () => {
    if (!preferenceCookiesAllowed()) return null;
    const cookie = document.cookie
      .split('; ')
      .find((item) => item.startsWith(`${tasteCookieName}=`));
    if (!cookie) return { tags: {}, types: {}, collections: {}, recent: [] };
    try {
      const profile = JSON.parse(decodeURIComponent(cookie.slice(tasteCookieName.length + 1)));
      return {
        tags: profile.tags || {},
        types: profile.types || {},
        collections: profile.collections || {},
        recent: Array.isArray(profile.recent) ? profile.recent : [],
      };
    } catch (_error) {
      return { tags: {}, types: {}, collections: {}, recent: [] };
    }
  };

  const writeTasteProfile = (profile) => {
    if (!profile || !preferenceCookiesAllowed()) return;
    const trimBucket = (bucket, limit) => Object.fromEntries(
      Object.entries(bucket || {}).sort((a, b) => Number(b[1]) - Number(a[1])).slice(0, limit)
    );
    profile.tags = trimBucket(profile.tags, 24);
    profile.types = trimBucket(profile.types, 12);
    profile.collections = trimBucket(profile.collections, 16);
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${tasteCookieName}=${encodeURIComponent(JSON.stringify(profile))}; Max-Age=15552000; Path=/; SameSite=Lax${secure}`;
  };

  const addInterest = (bucket, value, weight = 1) => {
    const key = String(value || '').trim().toLowerCase();
    if (!key) return;
    bucket[key] = Math.min(20, (Number(bucket[key]) || 0) + weight);
  };

  const rememberCurrentProduct = () => {
    const contextElement = document.getElementById('ChakchakProductContext');
    if (!contextElement || contextElement.dataset.chakRemembered === 'true' || !preferenceCookiesAllowed()) return;
    try {
      const context = JSON.parse(contextElement.textContent);
      const profile = readTasteProfile();
      if (!profile) return;
      addInterest(profile.types, context.type, 3);
      (context.tags || []).forEach((tag) => addInterest(profile.tags, tag, 2));
      (context.collections || []).forEach((collection) => addInterest(profile.collections, collection, 2));
      profile.recent = [context.handle, ...profile.recent.filter((handle) => handle !== context.handle)].slice(0, 12);
      writeTasteProfile(profile);
      contextElement.dataset.chakRemembered = 'true';
    } catch (_error) {
      // Ignore malformed product context and retain the popularity order.
    }
  };

  const personalizeProductCarousels = () => {
    const profile = readTasteProfile();
    if (!profile) return;
    const hasTaste = Object.keys(profile.tags).length || Object.keys(profile.types).length || Object.keys(profile.collections).length;
    if (!hasTaste) return;

    const scoreCard = (card, popularityIndex) => {
      const values = (name) => (card.dataset[name] || '').split('|').map((value) => value.trim().toLowerCase()).filter(Boolean);
      const typeScore = Number(profile.types[(card.dataset.productType || '').trim().toLowerCase()]) || 0;
      const tagScore = values('productTags').reduce((score, tag) => score + (Number(profile.tags[tag]) || 0), 0);
      const collectionScore = values('productCollections').reduce((score, collection) => score + (Number(profile.collections[collection]) || 0), 0);
      const recentlyViewedPenalty = profile.recent.includes(card.dataset.productHandle) ? 2 : 0;
      return {
        card,
        popularityIndex,
        score: (typeScore * 4) + (tagScore * 3) + (collectionScore * 2) - recentlyViewedPenalty,
      };
    };

    document.querySelectorAll('[data-chak-product-carousel]').forEach((carousel) => {
      if (carousel.dataset.chakRankingMode !== 'personalized') return;
      const track = carousel.querySelector('[data-chak-carousel-track]');
    const dots = [...carousel.querySelectorAll('.chak-carousel-dot')];
    const updateDots = () => {
      if (!track || !dots.length) return;
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 1);
      const index = Math.min(dots.length - 1, Math.round((track.scrollLeft / maxScroll) * (dots.length - 1)));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };
    requestAnimationFrame(() => {
      if (!track) return;
      track.scrollLeft = 0;
      updateDots();
    });
    track?.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        if (!track) return;
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        const target = Math.min(dotIndex * track.clientWidth, maxScroll);
        track.scrollTo({ left: target, behavior: 'smooth' });
      });
    });
      if (!track || track.dataset.chakPersonalized === 'true') return;
      const cards = [...track.querySelectorAll(':scope > [data-chak-product-card]')];
      if (cards.length < 2) return;

      const scoredCards = cards.map(scoreCard);

      scoredCards
        .sort((a, b) => b.score - a.score || a.popularityIndex - b.popularityIndex)
        .forEach(({ card }) => track.appendChild(card));
      track.dataset.chakPersonalized = 'true';
      carousel.closest('section')?.querySelector('[data-chak-personalized-label]')?.replaceChildren('Popular picks for you');
    });

    document.querySelectorAll('slideshow-component.resource-list__carousel').forEach((slideshow) => {
      if (slideshow.dataset.chakRankingMode !== 'personalized') return;
      if (slideshow.dataset.chakPersonalized === 'true') return;
      const scroller = slideshow.querySelector('slideshow-slides');
      const slides = [...slideshow.querySelectorAll('slideshow-slide')]
        .filter((slide) => slide.querySelector('[data-chak-product-card]'));
      if (!scroller || slides.length < 2) return;

      slides
        .map((slide, popularityIndex) => {
          const ranked = scoreCard(slide.querySelector('[data-chak-product-card]'), popularityIndex);
          return { slide, popularityIndex, score: ranked.score };
        })
        .sort((a, b) => b.score - a.score || a.popularityIndex - b.popularityIndex)
        .forEach(({ slide }) => scroller.appendChild(slide));
      slideshow.dataset.chakPersonalized = 'true';
      window.requestAnimationFrame(() => slideshow.select?.(0, undefined, { animate: false }));
    });
  };

  const init = () => {
    rememberCurrentProduct();
    personalizeProductCarousels();
    if (!document.documentElement.dataset.chakTasteConsentReady) {
      document.documentElement.dataset.chakTasteConsentReady = 'true';
      document.addEventListener('visitorConsentCollected', () => {
        rememberCurrentProduct();
        personalizeProductCarousels();
      });
      const personalizedCarouselObserver = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1))) {
          personalizeProductCarousels();
        }
      });
      personalizedCarouselObserver.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
    const reveals = document.querySelectorAll('.chak-reveal');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14 });
      reveals.forEach((el) => observer.observe(el));
    } else {
      reveals.forEach((el) => el.classList.add('is-visible'));
    }

    document.querySelectorAll('[data-chak-open-film]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.getAttribute('aria-controls'));
        if (dialog?.showModal) dialog.showModal();
      });
    });
    document.querySelectorAll('[data-chak-close-film]').forEach((button) => {
      button.addEventListener('click', () => {
        const dialog = button.closest('dialog');
        const video = dialog?.querySelector('video');
        video?.pause();
        dialog?.close();
      });
    });

    document.querySelectorAll('[data-chak-product-carousel]').forEach((carousel) => {
      if (initialized.has(carousel)) return;
      initialized.add(carousel);
      const track = carousel.querySelector('[data-chak-carousel-track]');
    const dots = [...carousel.querySelectorAll('.chak-carousel-dot')];
    const updateDots = () => {
      if (!track || !dots.length) return;
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 1);
      const index = Math.min(dots.length - 1, Math.round((track.scrollLeft / maxScroll) * (dots.length - 1)));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };
    requestAnimationFrame(() => {
      if (!track) return;
      track.scrollLeft = 0;
      updateDots();
    });
    track?.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        if (!track) return;
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        const target = Math.min(dotIndex * track.clientWidth, maxScroll);
        track.scrollTo({ left: target, behavior: 'smooth' });
      });
    });
      const move = (direction) => {
        const card = track?.querySelector('.chak-product');
        if (!track || !card) return;
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      };
      carousel.querySelector('[data-chak-carousel-prev]')?.addEventListener('click', () => move(-1));
      carousel.querySelector('[data-chak-carousel-next]')?.addEventListener('click', () => move(1));
    });

    document.querySelectorAll('[data-chak-slideshow]').forEach((slideshow) => {
      if (initialized.has(slideshow)) return;
      initialized.add(slideshow);
      const slides = [...slideshow.querySelectorAll('[data-chak-slide]')];
      const dots = [...slideshow.querySelectorAll('[data-chak-slide-dot]')];
      if (slides.length < 2) return;
      let current = 0;
      let timer;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      };
      const restart = () => {
        window.clearInterval(timer);
        if (slideshow.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => show(current + 1), Number(slideshow.dataset.interval) || 6000);
        }
      };
      slideshow.querySelector('[data-chak-slide-prev]')?.addEventListener('click', () => { show(current - 1); restart(); });
      slideshow.querySelector('[data-chak-slide-next]')?.addEventListener('click', () => { show(current + 1); restart(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.chakSlideDot)); restart(); }));
      slideshow.addEventListener('mouseenter', () => window.clearInterval(timer));
      slideshow.addEventListener('mouseleave', restart);
      slideshow.addEventListener('shopify:block:select', (event) => {
        const selected = slides.indexOf(event.target);
        if (selected >= 0) show(selected);
        window.clearInterval(timer);
      });
      restart();
    });

    // Some POD integrations add one mockup per color without assigning every
    // mockup as Shopify's featured variant image. In that case the variant
    // changes, but the gallery can remain on the first color. Match the chosen
    // color to the mockup filename/alt text and select its gallery slide.
    const syncProductColorMedia = () => {
      const selectedColor = document.querySelector(
        'input[type="radio"][data-option-name="Color"]:checked, input[type="radio"][data-option-name="Colour"]:checked'
      );
      const gallery = document.querySelector('media-gallery');
      if (!selectedColor || !gallery) return;

      const colorSlug = selectedColor.value
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-');
      const slides = [...gallery.querySelectorAll('slideshow-slide')];
      const matchingIndex = slides.findIndex((slide) => {
        const image = slide.querySelector('img');
        const source = `${image?.currentSrc || image?.src || ''} ${image?.alt || ''}`
          .toLowerCase()
          .replace(/%20/g, '-');
        return source.includes(`-${colorSlug}-`);
      });

      if (matchingIndex >= 0) {
        const slideshow = gallery.querySelector('slideshow-component');
        if (typeof slideshow?.select === 'function') {
          slideshow.select(matchingIndex, undefined, { animate: false });
        } else {
          // Safe fallback while the custom element is still initializing.
          const scroller = gallery.querySelector('slideshow-slides');
          const targetSlide = slides[matchingIndex];
          scroller?.scrollTo({ left: targetSlide.offsetLeft, behavior: 'instant' });
        }
      }
    };

    if (!document.documentElement.dataset.chakColorMediaReady) {
      document.documentElement.dataset.chakColorMediaReady = 'true';
      document.addEventListener('change', (event) => {
        if (!event.target?.matches?.(
          'input[type="radio"][data-option-name="Color"], input[type="radio"][data-option-name="Colour"]'
        )) return;

        // Select the matching slide immediately in the existing gallery.
        syncProductColorMedia();
      });

      // Fabric replaces the entire gallery after a variant selection. Correct
      // the newly inserted gallery in the same rendering cycle, before an
      // unrelated first slide can flash on screen.
      const productMediaObserver = new MutationObserver((mutations) => {
        const galleryWasReplaced = mutations.some((mutation) =>
          [...mutation.addedNodes].some((node) =>
            node.nodeType === 1 && (
              node.matches?.('media-gallery') || node.querySelector?.('media-gallery')
            )
          )
        );
        if (!galleryWasReplaced) return;
        syncProductColorMedia();
        window.requestAnimationFrame(syncProductColorMedia);
      });
      productMediaObserver.observe(document.querySelector('main') || document.body, {
        childList: true,
        subtree: true,
      });
    }

    window.setTimeout(syncProductColorMedia, 150);
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


/* Chak Chak: keep product media synced to the selected color. */
(() => {
  if (window.__ccColorMediaSyncAsset) return;
  window.__ccColorMediaSyncAsset = true;

  const slug = (value) => String(value || '')
    .toLowerCase()
    .trim()
    .replace(/grey/g, 'gray')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const selectedColor = () => {
    const checked = [...document.querySelectorAll('input[type=\"radio\"]:checked')];
    for (const input of checked) {
      const fieldset = input.closest('fieldset');
      const legend = fieldset?.querySelector('legend');
      const context = [input.name, input.getAttribute('aria-label'), legend?.textContent]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      if (context.includes('color') || context.includes('colour')) return input.value;
    }

    for (const select of document.querySelectorAll('select')) {
      const context = [select.name, select.getAttribute('aria-label')]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      if (context.includes('color') || context.includes('colour')) return select.value;
    }
    return '';
  };

  const syncColorMedia = () => {
    const color = selectedColor();
    if (!color) return;
    const wanted = slug(color);
    const wantedGrey = wanted.replace(/gray/g, 'grey');
    const matches = [...document.querySelectorAll('slideshow-controls img')].filter((img) => {
      const source = (img.currentSrc || img.src || img.dataset.src || '').split('?')[0].toLowerCase();
      return source.replace(/grey/g, 'gray').includes(wanted) || source.includes(wantedGrey);
    });
    if (!matches.length) return;
    const image = matches.find((img) => !img.closest('.product-details')) || matches[0];
    image.closest('button, [role=\"button\"], label')?.click();
  };

  const scheduleColorMedia = () => {
    [40, 300, 700, 1200].forEach((delay) => setTimeout(syncColorMedia, delay));
  };

  document.addEventListener('change', (event) => {
    if (event.target?.matches('input[type=\"radio\"], select')) scheduleColorMedia();
  }, true);
  document.addEventListener('variant:change', scheduleColorMedia);
  document.addEventListener('product:variant-change', scheduleColorMedia);
})();